// extracted by mini-css-extract-plugin
module.exports = {"submit":"submit-step_submit__1NvwW","textButton":"submit-step_textButton__1T_Wq","back":"submit-step_back__2zkI-","submitButton":"submit-step_submitButton__9Ku7X"};